// extracted by mini-css-extract-plugin
export default {"wrap":"AdminLayout_wrap__f8Lmy","header":"AdminLayout_header__dsgNy","link":"AdminLayout_link__LOTId"};